import * as momentRoutines from './momentRoutines';
import * as momentSelectors from './selectors';
import * as ui_actions from '../../redux/ui/actions';
import * as userRoutines from '../../sagas/routines/userRoutines';
import { connect } from 'react-redux';
import MomentDetails from '../../Components/Moments/MomentDetails';

const mapState2Props = (state: any) => {
    return {
        moment: momentSelectors.makeActiveMoment(state),
        posts: momentSelectors.makeMomentsWithComments(state),
    };
};

const mapDispatchToProps = {
    addComment: momentRoutines.addComment,
    blockMoment: momentRoutines.toggleCommentBlockOnMoment,
    fetchUserAvatar: userRoutines.fetchUserAvatar,
    removeMoment: momentRoutines.removeMoment,
    setActiveMoment: ui_actions.setActiveMoment,
};

export default connect(
    mapState2Props,
    mapDispatchToProps,
)(MomentDetails);
